<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        list: []
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        let params = {
          sort: 'DESC',
          list_type: 'short',
          auth_role: 1
        }

        this.list = []

        await get('layanan', { params })
        .then(response => {
          let res = response.data

          if (res.code === 200) {
            let data = res.data

            data.map((obj) => {
              this.list.push({
                text: obj.layanan_nama,
                value: obj.layanan_kode
              })
            })
          }
        })
      },
      config () {
        return {
          // CONFIG PARSING API
          api: 'layanan_content',

          // SINGLE
          single: false,

          // CHECKBOX
          checkbox: true,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Judul',
              width: '200px',
              value: 'lc_title',
              freeze: false,
              hide: false
            },
            {
              text: 'Deskripsi',
              width: '400px',
              value: 'lc_content',
              freeze: false,
              hide: false,
              format: 'regex'
            },
            {
              text: 'Tanggal',
              width: '150px',
              value: 'lc_create_datetime',
              freeze: false,
              hide: false,
              format: 'datetime'
            },
            {
              text: 'Status',
              width: '100px',
              value: 'lc_status',
              freeze: false,
              hide: false
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // PREFIX KEY
          prefix: 'lc_',

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'layanan_kode',
              label: 'Kode Layanan',
              type: 'select',
              placeholder: 'Contoh. KK (Kartu Keluarga)',
              value: '',
              option: this.list,
              width: '60%',
              required: true,
              rules: 'required'
            },
            {
              field: 'image',
              label: 'Gambar',
              type: 'image',
              placeholder: 'Contoh. https://via.placeholder.com/640x480.png/0000bb?text=images+ex',
              value: '',
              width: '100%',
              required: false
            },
            {
              field: 'title',
              label: 'Judul',
              type: 'text',
              placeholder: 'Contoh. Klaten Bersinar',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'content',
              label: 'Deskripsi',
              type: 'texteditor',
              placeholder: 'Contoh. Tuliskan deskripsi disini',
              value: '',
              rows: 5,
              required: false
            },
            {
              label: 'Column',
              type: 'column',
              sub: [
                {
                  field: 'type',
                  label: 'Tipe',
                  type: 'select',
                  placeholder: 'Contoh. Ketentuan',
                  value: 'terms',
                  option: [
                    {
                      text: 'Ketentuan',
                      value: 'terms'
                    }
                  ],
                  required: true,
                  rules: 'required',
                  col: 6
                },
                {
                  field: 'status',
                  label: 'Status',
                  type: 'select',
                  placeholder: 'Contoh. Publish',
                  value: '',
                  option: [
                    {
                      text: 'Publish',
                      value: 'publish'
                    },
                    {
                      text: 'Draft',
                      value: 'draft'
                    }
                  ],
                  required: false,
                  col: 4
                }
              ]
            }
          ],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: true,
              api: 'layanan_content/create',
              window: false,
              href: ''
            },
            edit: {
              button: true,
              api: 'layanan_content/update',
              window: false,
              href: ''
            },
            delete: {
              button: true,
              api: 'layanan_content/delete'
            },
            detail: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: false,
              api: ''
            },
            hide: {
              button: false,
              api: ''
            }
          }
        }
      }
    }
  }
</script>